<template>
  <v-hover v-slot="{ hover }">
    <v-row
      align="center"
      :class="[
        saldato ? 'grey--text lighten-4' : '',
        hover ? 'grey lighten-4' : '',
        contabile.fake ? 'red lighten-5 py-2' : ''
      ]"
      class="px-2"
      no-gutters
    >
      <v-snackbar
        v-model="alertError"
        top
        color="error"
        icon="mdi-alert"
        border="left"
        elevation="2"
        class="mb-2"
        timeout="6000"
      >
        Errore durante la modifica della contabile.
      </v-snackbar>
      <v-col cols="2" :class="contabile.fake ? 'red--text' : ''">
        <div class="d-flex align-center">
          <v-checkbox
            v-if="modalitaSelezioneFattura && eleggibilePerFattura"
            :input-value="selezionatoFattura"
            :disabled="!!clienteSelezionatoFattura && clienteSelezionatoFattura !== contabile.cliente"
            dense
            hide-details
            class="mt-0 pt-0 mr-1 flex-grow-0"
            @change="$emit('toggle-selezione-fattura', contabile)"
          ></v-checkbox>
          <span>{{ contabile.fake ? "Record Mancante" : cliente ? cliente.nome : "—" }}</span>
        </div>
      </v-col>
      <v-col cols="1" class="text-no-wrap"> {{ dataBreve }}</v-col>
      <v-col cols="1">
        <span
          v-if="!contabile.fake"
          class="pa-1"
          :class="
            contabile.tipo == 1
              ? contabile.verde
                ? 'green--text'
                : 'blue--text'
              : contabile.tipo == 2
              ? contabile.verde
                ? 'text-no-wrap green white--text'
                : 'text-no-wrap blue white--text'
              : 'purple--text'
          "
        >
          € {{ contabile.importo.toFixed(2) }}
        </span>
        <v-tooltip
          v-if="contabile.tipo === 1 && contabile.verde && documentiCollegatiFattura.length"
          bottom
        >
          <template v-slot:activator="{ on }">
            <v-icon x-small color="blue darken-1" class="ml-1" v-on="on"
              >mdi-swap-horizontal</v-icon
            >
          </template>
          <span>Regolarizzato tramite Fattura di Copertura: {{ tooltipDocumentiFattura }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="1" class="text-truncate grey--text text-caption">
        <v-tooltip v-if="contabile.metodo_pagamento_misto" bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">Misto</span>
          </template>
          <span>Coperture con metodi di pagamento diversi — dettaglio nel dialog "Copertura debito"</span>
        </v-tooltip>
        <template v-else>{{ nomeMetodo(contabile.metodo_pagamento) }}</template>
      </v-col>
      <v-col cols="1">
        <div class="d-flex align-center">
          <span class="text-truncate">{{ contabile.ddt }}</span>
          <v-tooltip v-if="documentiCollegatiFattura.length" bottom>
            <template v-slot:activator="{ on }">
              <v-icon x-small color="purple darken-1" class="ml-1" v-on="on"
                >mdi-file-percent-outline</v-icon
              >
            </template>
            <span>Coperto da Fattura di Copertura: {{ tooltipDocumentiFattura }}</span>
          </v-tooltip>
          <v-tooltip v-if="documentiCollegatiCredito.length" bottom>
            <template v-slot:activator="{ on }">
              <v-icon x-small color="teal darken-1" class="ml-1" v-on="on">mdi-cash-plus</v-icon>
            </template>
            <span>Coperto da Pagamento Cliente: {{ tooltipDocumentiCredito }}</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col cols="1">
        <v-btn v-if="contabile.id_conteggio" icon color="purple" @click="$refs.dettaglio_conteggio.open()"><v-icon>mdi-clipboard-list</v-icon></v-btn>
        <DettaglioConteggio :id_conteggio="contabile.id_conteggio" :ordine="ordine" ref="dettaglio_conteggio"/>
      </v-col>
      <v-col cols="1">
        <ContabileOrdineRef
          :id_ordine="contabile.id_ordine"
          :id_subconteggio="contabile.id_subconteggio"
          :readonly="contabile.fake"
          ref="contabileOrdineRef"
        />
      </v-col>
      <v-col cols="1" class="mb-2">
        <v-tooltip v-if="!contabile.fake && contabile.tipo == 2" bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <v-checkbox
                :input-value="true"
                :readonly="true"
                :disabled="true"
                dense
                hide-details
              ></v-checkbox>
            </span>
          </template>
          <span>Un pagamento cliente è sempre considerato saldato</span>
        </v-tooltip>
        <v-tooltip v-else-if="!contabile.fake && attesaFatturaBloccante" bottom>
          <template v-slot:activator="{ on }">
            <div class="d-flex align-center" v-on="on">
              <v-checkbox
                :input-value="false"
                :indeterminate="true"
                :readonly="true"
                :disabled="true"
                dense
                hide-details
              ></v-checkbox>
              <v-icon small color="purple darken-1" class="ml-n1 mt-2">mdi-timer-sand</v-icon>
            </div>
          </template>
          <span>
            Coperto da fattura non ancora pagata (€ {{ contabile.in_attesa_fattura.importo.toFixed(2) }}{{ ddtAttesaFattura ? " — DDT " + ddtAttesaFattura : "" }})
          </span>
        </v-tooltip>
        <v-menu
          v-else-if="!contabile.fake && contabile.tipo == 1 && !saldato"
          v-model="metodoMenuOpen"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <div class="d-flex align-center">
              <v-checkbox
                :input-value="false"
                :indeterminate="isPartial"
                :readonly="true"
                :loading="loadingSaldato"
                :disabled="loadingSaldato"
                dense
                hide-details
                v-on="on"
              ></v-checkbox>
              <v-tooltip v-if="contabile.in_attesa_fattura" bottom>
                <template v-slot:activator="{ on: onIcon }">
                  <v-icon small color="purple darken-1" class="ml-n1 mt-2" v-on="onIcon"
                    >mdi-timer-sand</v-icon
                  >
                </template>
                <span>
                  € {{ contabile.in_attesa_fattura.importo.toFixed(2) }} in attesa — fattura pagata al {{ percentualePagataAttesaFattura }}
                </span>
              </v-tooltip>
            </div>
          </template>
          <v-list dense>
            <v-subheader>Segna come pagato con...</v-subheader>
            <v-list-item
              v-for="m in metodiPagamento"
              :key="m.value"
              @click="registraPagamentoRapido(m.value)"
            >
              <v-list-item-title>{{ m.nome }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tooltip v-else-if="!contabile.fake && contabile.tipo == 3 && contabile.rate_pagamento" bottom>
          <template v-slot:activator="{ on }">
            <div class="d-flex align-center" v-on="on">
              <v-checkbox
                :input-value="saldato"
                :indeterminate="!saldato"
                :readonly="true"
                :disabled="true"
                dense
                hide-details
              ></v-checkbox>
              <v-icon small color="purple darken-1" class="ml-n1 mt-2">mdi-cash-multiple</v-icon>
            </div>
          </template>
          <span>
            Rate: € {{ contabile.rate_pagamento.incassato.toFixed(2) }}<template v-if="contabile.rate_pagamento.pianificato"> (+€ {{ contabile.rate_pagamento.pianificato.toFixed(2) }} pianificato)</template> su € {{ contabile.rate_pagamento.totale.toFixed(2) }}
          </span>
        </v-tooltip>
        <v-tooltip v-else-if="!contabile.fake && contabile.tipo == 3 && !saldato" bottom>
          <template v-slot:activator="{ on }">
            <div class="d-flex align-center" v-on="on">
              <v-checkbox
                :input-value="false"
                :readonly="true"
                :disabled="true"
                dense
                hide-details
              ></v-checkbox>
              <v-icon small color="purple darken-1" class="ml-n1 mt-2">mdi-file-percent-outline</v-icon>
            </div>
          </template>
          <span>Crea prima una rata dal dialog "Erosione credito"</span>
        </v-tooltip>
        <v-checkbox
          v-else-if="!contabile.fake"
          v-model="saldato"
          :readonly="true"
          :loading="loadingSaldato"
          :disabled="loadingSaldato"
          :label="formatData(contabile.ts_saldo)"
          dense
          hide-details
          @click="toggle_saldato(true)"
        ></v-checkbox>
        <v-dialog v-if="!contabile.fake" v-model="dialogConfermaSaldato" max-width="400">
          <v-card>
            <v-card-title class="headline">Conferma</v-card-title>
            <v-card-text>
              Rimuovere tutte le coperture registrate su questo debito e tornare a "non pagato"?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="confermaSaldato">Sì</v-btn>
              <v-btn color="red darken-1" text @click="annullaSaldato">No</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="1">
        <v-tooltip v-if="!contabile.fake && contabile.residuo !== undefined" bottom>
          <template v-slot:activator="{ on }">
            <span v-on="on" :class="residuoColorName + '--text'" class="text-no-wrap">
              <v-icon x-small :color="residuoColorName" class="mr-1">{{ residuoIcon }}</v-icon
              >€ {{ contabile.residuo.toFixed(2) }}
            </span>
          </template>
          <span>{{ residuoTooltip }}</span>
        </v-tooltip>
      </v-col>
      <v-col cols="1">
        {{ contabile.note }}
      </v-col>
      <v-col cols="1">
        <v-dialog v-if="!contabile.fake" v-model="dialogElimina" width="400">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" @click="erroreElimina = null">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title> Elimina contabile </v-card-title>
            <v-card-text>
              Sei sicuro di voler eliminare il contabile?
              <v-alert v-if="erroreElimina" type="error" dense text class="mt-3">
                {{ erroreElimina }}
              </v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="grey" text @click="dialogElimina = false"
                >Annulla</v-btn
              >
              <v-btn
                color="red"
                outlined
                :loading="loadingElimina"
                @click="eliminaContabile"
                >Elimina</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <modifica_contabile
          v-if="!contabile.fake"
          :contabile="contabile"
          @update-contabile="updateContabile"
        />
        <AllocazioneDialog
          v-if="!contabile.fake"
          :contabile="contabile"
          @cambiato="updateContabile"
        />
      </v-col>
    </v-row>
  </v-hover>
</template>

<script>
import modifica_contabile from "./modifica_contabile.vue";
import contabile_element_mixin from "../mixin/contabile_element_mixin";
import ContabileOrdineRef from "./contabile_ordine_ref.vue";
import DettaglioConteggio from "../../Conteggi/desktop/dettaglio_conteggio/conteggio_dettaglio.vue";
import AllocazioneDialog from "./allocazione_dialog.vue";
import moment from "moment";
import { nomeMetodoPagamento } from "../mixin/metodoPagamento";
export default {
  components: {
    modifica_contabile,
    DettaglioConteggio,
    ContabileOrdineRef,
    AllocazioneDialog,
  },
  mixins: [contabile_element_mixin],
  props: {
    // "Crea coperture con Fattura": selezione multi-riga per proporre una
    // Fattura Anticipata/Posticipata che eroda esattamente i movimenti
    // scelti. Gestita dal genitore (contabili_desktop_main.vue), qui solo
    // visualizzata/notificata — nessuno stato di selezione locale.
    modalitaSelezioneFattura: { type: Boolean, default: false },
    clienteSelezionatoFattura: { type: String, default: null },
    selezionatoFattura: { type: Boolean, default: false },
  },
  computed: {
    // Stessi criteri usati lato backend per solo_vergini=true&verde=true
    // (vedi get_debiti_aperti_cliente): un debito verde, ancora aperto, e
    // senza nessuna copertura già registrata è l'unico tipo di movimento
    // che una Fattura Anticipata/Posticipata può erodere.
    eleggibilePerFattura() {
      return (
        !this.contabile.fake &&
        this.contabile.tipo === 1 &&
        this.contabile.verde === true &&
        !this.contabile.saldato &&
        this.contabile.importo_coperto === undefined
      );
    },
    // Data compressa (DD/MM/YY) per fare spazio alla colonna Metodo senza
    // aggiungerne una nuova alla riga — già stretta di suo.
    dataBreve() {
      if (!this.contabile || !this.contabile.ts) return "";
      return moment.unix(this.contabile.ts).format("DD/MM/YY");
    },
  },
  methods: {
    nomeMetodo(value) {
      return nomeMetodoPagamento(value) || "";
    },
  },
};
</script>